const FireBlanketIcon = ({ strokeColor = '#808080' }) => {
  return (
    <svg
      viewBox="0 0 795.1 795.1"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <defs>
        <style>{`
          .cls-1 {
            fill: #fcfcfc;
          }
          .cls-2 {
            fill: #4d4d4d;
          }
          .cls-3 {
            stroke: ${strokeColor};
            stroke-width: 50px;
          }
          .cls-3, .cls-4 {
            fill: none;
            stroke-miterlimit: 10;
          }
          .cls-5 {
            fill: #fefefe;
          }
          .cls-4 {
            stroke: #fff;
            stroke-width: 20px;
          }
        `}</style>
      </defs>
      <g id="Circles">
        <circle id="Grey_Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
        <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
        <circle id="White_Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path
            className="cls-5"
            d="M529.78,243.41c13.23,6.07,26.64,2.15,39.61,3.47,5.97.61,12.17,1.33,17.67,3.52,5.19,2.07,8.78,7.03,6.91,13.05-1.88,6.05-6.23,10.01-13.35,9.31-1.07-.11-2.15-.01-4.23-.01v330.09c0,14.08-5.87,20.01-19.99,20.01-105.8,0-211.61,0-317.41-.03-14.92,0-20.6-5.9-20.59-21.11.02-107.15.04-214.31.05-321.46v-7.09c-12.41-.91-17.86-4.83-17.82-12.42.05-7.82,8.52-14.74,19.36-13.76,23.12,2.08,44.21-3.74,65.23-12.74,27.62-11.82,55.85-22.23,83.86-33.12,4.07-1.58,6.23-3.28,6.31-8.46.18-11.47,9.43-19.91,20.79-20.36,11.78-.46,22.1,7.35,23.12,18.82.52,5.87,3.08,8.32,7.97,10.31,34,13.85,67.93,27.87,102.52,41.99M452.49,272.7h-209.3v325.09h308.45v-325.09h-99.15M384.24,219.35c-20.92,8.81-41.84,17.62-64.16,27.02h153.02c-10.22-4.42-19.27-7.99-28.02-12.19-18.9-9.08-38.08-16.81-60.84-14.83Z"
          />
          <path
            className="cls-1"
            d="M471.93,407.23c2.92,3.2,7.43,6.54,7.1,9.3-2.51,20.71,6.96,39.39,9.13,59.16,3.78,34.37-9.12,63.63-40.43,80.98-5.67,3.14-11.58,2.46-15.54-3.69-3.67-5.71-2.26-12.75,3.88-16.66,19.55-12.46,29.59-30.39,28.19-53.27-.75-12.32-5.09-24.42-7.8-36.61-.85-.26-1.7-.53-2.55-.79-3.91,9.65-8.51,19.1-11.49,29.03-1.85,6.16-4.82,11.29-10.7,11.07-4.54-.17-10.23-3.4-13.15-7.07-12.28-15.44-11.51-33.03-6.84-51.11,3.39-13.14,8.28-26.25,4.31-40.2-2.88-10.13-7.72-19.06-16.78-26.38-4.03,22.21-16.54,38.58-30.72,54.11-8.87,9.72-17.97,19.44-25.34,30.27-16.45,24.15-13.7,51.4,6.38,72.63,4.23,4.48,8.95,8.54,13.73,12.44,6.48,5.28,7.85,10.46,3.61,16.65-4.43,6.47-10.76,6.1-16.28,2.65-21.89-13.66-36.52-32.71-41.49-58.5-6.38-33.11,9.25-57.99,30.12-80.99,8.33-9.17,16.95-18.14,24.49-27.94,10.22-13.3,14.45-28.3,10.77-45.34-.8-3.72,1.05-9.28,3.7-12.06,2.06-2.16,8-2.92,10.97-1.57,23.75,10.86,56.09,42.48,52.67,78.08-.93,9.7-3.36,19.27-5.53,31.3,6.12-6.64,10.46-11.88,15.36-16.54,5.43-5.16,11.02-10.52,20.27-8.97M436.56,431.25c-.09.98-.19,1.95-.28,2.93.47-.73.94-1.46.28-2.93Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default FireBlanketIcon;
